module.exports = {
  'price-up': 'price asc',
  'price-down': 'price desc',
  latest: 'createdAt desc',
};
